module.exports = __webpack_public_path__ + "static/media/step1-cht.b4160516.png";